import * as React from 'react'
import { PageContext } from 'contexts'

export const useDynamicPageTitle = () => {
  const { state, dispatch } = React.useContext(PageContext)

  return {
    state,
    dispatch,
  }
}
